module.exports = __webpack_public_path__ + "img/smart_marketing.25675576.png";